import React from "react";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import ProvidersSection from "@/components/landing/ProvidersSection";
import OpenClawSection from "@/components/landing/OpenClawSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import ChatDemoSection from "@/components/landing/ChatDemoSection";
import ThemesSection from "@/components/landing/ThemesSection";
import PrivacySection from "@/components/landing/PrivacySection";
import OpenSourceSection from "@/components/landing/OpenSourceSection";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      {/* Background effects */}
      <div className="fixed inset-0 bg-gradient-hero pointer-events-none" />
      <div className="fixed inset-0 grid-pattern opacity-30 pointer-events-none" />

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <main>
          <HeroSection />
          <ProvidersSection />
          <OpenClawSection />
          <FeaturesSection />
          <HowItWorksSection />
          <ChatDemoSection />
          <ThemesSection />
          <PrivacySection />
          <OpenSourceSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;
